import React from 'react'
import Navbar from './components/Navbar';
import { BrowserRouter as Router,Routes,Route } from 'react-router-dom';
import Home from './pages/home/Home';
import Footer from './components/footer/Footer';
import LeadershipPage from './pages/leadership/LeadershipPage';
import PortfolioPage from './pages/portfolio/PortfolioPage';
import Operations from './pages/Operations/Operations';
import AboutUs from './pages/about/AboutUs';
import OurMarqueeDeployments from './pages/OurMarqueeDeployments/OurMarqueeDeployments';
import OurValues from './pages/OurValues/OurValues';
import LifeatCrest from './pages/LifeatCrest/LifeatCrest';
import Announcement from './pages/announcement/Announcement';
import CodesAndPolicies from './pages/CodesAndPolicies/CodesAndPolicies';
import OurPartners from './pages/OurPartners/OurPartners';
import Newsroom from './pages/newsroom/Newsroom';
import Careers from './pages/careers/Careers';
import ContactUs from './pages/ContactUs/ContactUs';
import OurInitiatives from './pages/OurInitiatives/OurInitiatives';
import Awards from './pages/awards/Awards';
import Privacy from './pages/privacy/Privacy';
import Searchpg from './pages/search/Searchpg';
import Sustainability from './pages/sustainability/Sustainability';
import ScrollTop from './components/ScrollTop';




const App = () => {
  return (
    <Router>
    <ScrollTop/>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/about-us' element={<AboutUs/>}/>
        <Route path='/leadership' element={<LeadershipPage/>}/>
        <Route path='/our-portfolio' element={<PortfolioPage/>}/>
        <Route path='/our-operations' element={<Operations/>}/>
        <Route path='/our-marquee-deployment' element={<OurMarqueeDeployments/>}/>
        <Route path='/our-values' element={<OurValues/>}/>
        <Route path='/life-at-crest' element={<LifeatCrest/>}/>
        <Route path='/announcement' element={<Announcement/>}/>
        <Route path='/codes-policies' element={<CodesAndPolicies/>}/>
        <Route path='/our-partners' element={<OurPartners/>}/>
        <Route path='/newsroom' element={<Newsroom/>}/>
        <Route path='/careers' element={<Careers/>}/>
        <Route path='/get-in-touch' element={<ContactUs/>}/>
        <Route path='/our-initiatives' element={<OurInitiatives/>}/>
        <Route path='/awards-and-recognitions' element={<Awards/>}/>
        <Route path='/privacy-policy' element={<Privacy/>}/>
        <Route path='/:query' element={<Searchpg/>}/>
        <Route path='/sustainability' element={<Sustainability/>}/>

      </Routes>
      <Footer/>
    </Router>
  )
}

export default App
